import { StockDocument } from "../models"
import { FromReferencePayload, InventoryAdjustmentPayload, PatchPayload, QuickCreatePayload } from "../services"
import { ACTION_TYPES } from "./types"

export const Action = {
    fetch: (id: string) => {
        return {
            type: ACTION_TYPES.FETCH,
            payload: id
        }
    },

    reload: () => {
        return {
            type: ACTION_TYPES.RELOAD,
        }
    },

    fetchSuccess: (payload: StockDocument) => {
        return {
            type: ACTION_TYPES.FETCH_SUCCESS,
            payload: payload,
        }
    },

    create: (payload: PatchPayload) => {
        return {
            type: ACTION_TYPES.CREATE,
            payload: payload,
        }
    },

    createFromReference: (payload: FromReferencePayload) => {
        return {
            type: ACTION_TYPES.CREATE_FROM_REFERENCE,
            payload: payload,
        }
    },

    delete: () => {
        return {
            type: ACTION_TYPES.DELETE,
        }
    },

    clear: () => {
        return {
            type: ACTION_TYPES.CLEAR,
        }
    },

    unarchive: () => {
        return {
            type: ACTION_TYPES.UNARCHIVE,
        }
    },

    markAsDone: () => {
        return {
            type: ACTION_TYPES.MARK_AS_DONE,
        }
    },
    
    receiveItems: (payload: InventoryAdjustmentPayload) => {
        return { 
            type: ACTION_TYPES.ADJUST_INVENTORY,
            payload: payload
        }
    },
    sendItems: (payload: InventoryAdjustmentPayload) => {
        return { 
            type: ACTION_TYPES.ADJUST_INVENTORY,
            payload: payload
        }
    },
    
    quickCreate: (payload: QuickCreatePayload) => {
        return {
            type: ACTION_TYPES.QUICK_CREATE_STOCK_DOCUMENT,
            payload: payload,
        }
    },
}






// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/actions/actions.ts